import { validate } from '../../../../../../../helpers/validate';
import { useLang } from '../../../../../../../hooks/use-lang';
import { useToggle } from '../../../../../../../hooks/use-toggle';
import { useAuthStore } from '../../../../../../../store/use-auth-store';
import { useManagerStore } from '../../../../../../../store/use-manager-store';

export const useProfileSecurity = () => {
  const { managerProfile, handleUpdateManagerProfile } = useManagerStore();
  const {
    changePassword,
    changePasswordData,
    handleUpdateChangePasswordData,
    isLoading: isChangingPassword,
  } = useAuthStore();
  const { t } = useLang();

  const phones = managerProfile?.additional_phones;
  const emails = managerProfile?.additional_emails;

  const handleAddPhone = () => {
    handleUpdateManagerProfile({ additional_phones: [...(phones || []), ''] });
  };

  const handleAddEmail = () => {
    handleUpdateManagerProfile({ additional_emails: [...(emails || []), ''] });
  };

  const handleChangePhone = (editValue: string, editIndex: number) => {
    handleUpdateManagerProfile({
      additional_phones: phones?.map((value, index) => (editIndex === index ? editValue : value)),
    });
  };

  const handleChangeEmail = (editValue: string, editIndex: number) => {
    handleUpdateManagerProfile({
      additional_emails: emails?.map((value, index) => (editIndex === index ? editValue : value)),
    });
  };

  const handleDeletePhone = (index: number) => {
    handleUpdateManagerProfile({ additional_phones: phones?.filter((_, i) => i !== index) });
  };

  const handleDeleteEmail = (index: number) => {
    handleUpdateManagerProfile({ additional_emails: emails?.filter((_, i) => i !== index) });
  };

  const [isEdit, toggleIsEdit] = useToggle(false);

  const handleSavePassword = () => {
    const isValid = validate({
      login: { rule: () => !!changePasswordData?.login?.length },
      oldPassword: { rule: () => !!changePasswordData?.old_password?.length },
      password: { rule: () => !!changePasswordData?.password?.length },
      repeatPassword: { rule: () => !!changePasswordData?.repeatPassword?.length },
    });
    if (!isValid) return;
    changePassword();
    toggleIsEdit();
  };

  return {
    emails,
    phones,
    handleAddPhone,
    handleAddEmail,
    handleDeletePhone,
    handleDeleteEmail,
    handleChangeEmail,
    handleChangePhone,
    t,
    handleUpdateChangePasswordData,
    changePasswordData,
    handleSavePassword,
    isChangingPassword,
    isEdit,
    toggleIsEdit,
  };
};
